import { motion } from "framer-motion";
import { Check } from "lucide-react";

const levels = [
  {
    n: "01",
    medal: "Experience Center",
    title: "Indoor Showroom",
    points: ["Indoor showroom & display models", "Product sales", "Training & marketing support", "Build your local customer base"],
  },
  {
    n: "02",
    medal: "Experience & Development Hub",
    title: "Expand Revenue Streams",
    points: ["Everything in Level 1", "Outdoor display village", "Host events & demonstrations", "Development opportunities"],
  },
  {
    n: "03",
    medal: "Destination Dealership & Resort",
    title: "Become The Destination",
    points: ["Resort-style tiny-home communities", "Luxury glamping resorts", "Attract investors & landowners", "A legacy business for generations"],
    featured: true,
  },
];

export const Levels = () => {
  return (
    <section id="levels" className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10">
      <div className="mb-16 max-w-2xl">
        <p className="text-xs uppercase tracking-[0.3em] text-oed-gold mb-6">Three Levels of Success</p>
        <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl leading-[1.05]">
          Choose how far you want to build.
        </h2>
      </div>

      <div className="grid lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {levels.map((l, i) => (
          <motion.div
            key={l.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 }}
            data-testid={`level-card-${l.n}`}
            className={`p-10 md:p-12 ${l.featured ? "bg-oed-gold text-black" : "bg-oed-surface"}`}
          >
            <div className="flex items-baseline justify-between">
              <span className={`font-display font-black text-6xl tracking-tighter ${l.featured ? "text-black/20" : "text-white/10"}`}>{l.n}</span>
              <span className={`text-[10px] uppercase tracking-[0.25em] ${l.featured ? "text-black/60" : "text-oed-gold"}`}>{l.medal}</span>
            </div>
            <h3 className="mt-8 font-display font-bold text-2xl md:text-3xl tracking-tight">{l.title}</h3>
            <ul className="mt-8 space-y-4">
              {l.points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm leading-relaxed">
                  <Check size={16} className={`mt-0.5 shrink-0 ${l.featured ? "text-black" : "text-oed-gold"}`} />
                  <span className={l.featured ? "text-black/80" : "text-white/60"}>{p}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
